import React, { useEffect } from 'react';
import { Table, Badge } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInvoicesByUser } from '../../store/invoices/actions';
import moment from 'moment';

const InvoiceTable = () => {
  const admin = useSelector((state) => state.Auth.admin);
  const loading = useSelector((state) => state.Invoice.loading);
  const invoices = useSelector((state) => state.Invoice.invoices);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchInvoicesByUser(admin.id));
  }, [admin.id]);

  return (
    <div className="table-responsive">
      <Table className="table-nowrap mb-0">
        <thead className="thead-light">
          <tr>
            <th scope="col">Data</th>
            <th scope="col">Importo</th>
            <th scope="col">IVA</th>
            <th scope="col">Stato</th>
            <th scope="col">Azioni</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <td colSpan="5" className="text-center">
                Caricamento...
              </td>
            </tr>
          )}
          {Array.isArray(invoices) &&
            invoices.length &&
            invoices.map((invoice, index) => (
              <tr key={index}>
                <td>
                  {invoice.createdAt &&
                    moment(invoice.createdAt).format('DD MMMM YYYY')}
                </td>
                <td>
                  <span className="font-weight-bold">
                    {invoice.amount.toFixed(2)} {invoice.currency.toUpperCase()}
                  </span>
                </td>
                <td>22%</td>
                <td>
                  <Badge
                    color={invoice.status === 'paid' ? 'success' : 'warning'}
                    className="font-size-12">
                    {invoice.status === 'paid' ? 'Pagata' : 'In attesa'}
                  </Badge>
                </td>
                <td>
                  <div className="d-flex gap-2">
                    <a
                      href={invoice.stripeInvoiceURL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-sm btn-light"
                      title="Visualizza online">
                      <i className="bx bx-link-external"></i>
                    </a>
                    <a
                      href={invoice.stripeInvoicePDF}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-sm btn-light"
                      title="Scarica PDF">
                      <i className="bx bx-download"></i>
                    </a>
                  </div>
                </td>
              </tr>
            ))}
          {invoices.length === 0 && (
            <tr>
              <td colSpan="5" className="text-center">
                Nessuna fattura trovata
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default InvoiceTable;
